import * as React from "react"
import styled from "styled-components"

import { ReactComponent as errorDesktopSVG } from "./error-desktop.svg"
import { ReactComponent as errorSVG } from "./error.svg"

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
`

const MobileSVG = styled(errorSVG)`
  margin-top: 84px;
  display: none;
  @media screen and (max-width: ${(props) => props.theme.breakpoint.sm}) {
    display: initial;
  }
`

const DesktopSVG = styled(errorDesktopSVG)`
  margin-top: 40px;
  display: none;
  @media screen and (min-width: ${(props) => props.theme.breakpoint.sm}) {
    display: initial;
  }
`

const Message = styled.div`
  margin: 8px 0;
  color: ${(props) => props.theme.color.lightBlue};
`

export const ServerError = () => (
  <Container>
    <MobileSVG />
    <DesktopSVG />
    <Message>由於系統繁忙，請稍後再試</Message>
  </Container>
)

interface Props {
  renderError?: React.ReactNode
}

export default class ErrorBoundary extends React.PureComponent<
  Props,
  {
    hasError: boolean
    error?: {
      err: Error
      info: React.ErrorInfo
    }
  }
> {
  public constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  public static defaultProps = {
    renderError: <ServerError />,
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      hasError: true,
      error: {
        err: error,
        info: errorInfo,
      },
    })
    return
  }

  public render() {
    if (this.state.hasError) {
      return this.props.renderError
    }

    return this.props.children
  }
}
